export const RESULTS_LIMIT = 100;
